module.exports = __webpack_public_path__ + "img/knx.ba9c81c1.png";